export default __webpack_public_path__ + "static/media/bannerr7.3aeec8ad.webp";